import React, { useState, useEffect, useRef } from "react"
import SceneObjects from "./containers/SceneObjects"
import Controls from "./containers/Controls"
import Camera from "./components/Camera"
import { Canvas, useThree } from "react-three-fiber"
import "./App.css"
import Main from "./components/Main"
import { useGesture } from "react-use-gesture"
import { useSpring } from "react-spring/three"
import * as easings from "d3-ease"

const speed = 25

document.addEventListener("gesturestart", (e) => {
  e.preventDefault()
})
document.addEventListener("gesturechange", (e) => {
  e.preventDefault()
})

function App() {
  const [init, setInit] = useState(false)
  const [controlsOn, setControlsOn] = useState(false)
  const [overInclined, setOverInclined] = useState(null)
  const [ended, setEnded] = useState(false)
  const [supportsOrientation, setSupportsOrientation] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const delta = useRef([0, 0, 0])
  const [{ fov }, set] = useSpring(() => ({
    fov: 55,
    easing: easings.easeCubic,
  }))

  useEffect(() => {
    document.addEventListener("pointerlockchange", onPointerlockChange, false)
    return () => {
      document.removeEventListener(
        "pointerlockchange",
        onPointerlockChange,
        false
      )
    }
  }, [])

  const pinchToZoom = ({ offset }) => {
    if (init && supportsOrientation) {
      set({ fov: 80 - offset[0] })
    }
  }

  const zoom = ({ offset, wheeling }) => {
    if (init) {
      const value = 75 - offset[1] / speed
      set({ fov: value, immediate: wheeling })
    }
  }

  const drag = (state) => {
    if (init) {
      console.log(state.delta)
      delta.current = [...state.delta, 0]
    }
  }

  const bind = useGesture(
    {
      onPinch: (state) => pinchToZoom(state),
      onWheel: (state) => zoom(state),
      onDrag: (state) => drag(state),
    },
    {
      pinch: { distanceBounds: { min: 10, max: 70 } },
      wheel: {
        bounds: { top: 15 * speed, bottom: 60 * speed },
        axis: "y",
        rubberband: 0.01,
      },
    }
  )

  const onPointerlockChange = () => {
    const on = document.pointerLockElement !== null
    setControlsOn(on)
  }

  useEffect(() => {
    if (window.DeviceOrientationEvent && "ontouchstart" in window) {
      setSupportsOrientation(true)
    }
  }, [])

  const handleStart = () => {
    if (!init || !controlsOn) {
      // console.log("start")
      console.log("try to ask", init, supportsOrientation)
      if (
        window.DeviceOrientationEvent !== undefined &&
        typeof window.DeviceOrientationEvent.requestPermission === "function"
      ) {
        console.log("passed condition")
        window.DeviceOrientationEvent.requestPermission().then((response) => {
          console.log("check if granted")
          if (response === "granted") {
            console.log("granted")
            setInit(true)
            setControlsOn(true)
          } else {
            console.log("show error message here")
          }
        })
      } else {
        console.log("no orientation")
        setInit(true)
        setControlsOn(true)
      }
    }
  }

  // const init = useControl("set init", {
  //   type: "boolean",
  //   value: false,
  // })

  // console.log(canvasRef.current)

  return (
    <>
      <Main
        bind={bind}
        loaded={loaded}
        controlsOn={controlsOn}
        supportsOrientation={supportsOrientation}
        handleStart={handleStart}
      />
      {overInclined && (
        <div className="over-inclined">
          <p>
            Все, что важно – перед глазами.
            <br />
            Переведите устройство в линию горизонта.
          </p>
        </div>
      )}
      <Canvas pixelRatio={window.devicePixelRatio}>
        {/* <Stats /> */}
        <Controls
          passOverInclination={setOverInclined}
          init={init}
          controlsOn={controlsOn}
          supportsOrientation={supportsOrientation}
          ended={ended}
        />
        <Camera
          delta={delta}
          fov={fov}
          init={init}
          handleEnded={() => setEnded(true)}
        />
        {/* <Lights /> */}
        <SceneObjects ended={ended} setLoaded={setLoaded} />
      </Canvas>
      {/* <ControlsGui /> */}
    </>
  )
}

export default App
